// @flow

import { Component, type Node } from 'react'

type Props = { children: Node }
type State = { failed: boolean }

// A QR failure must only hide the QR, never the crash screen around it.
// The error is not rethrown or reported: the crash itself is already being reported.
export class QRBoundary extends Component<Props, State> {
  static getDerivedStateFromError(): State {
    return { failed: true }
  }

  constructor(props: Props) {
    super(props)
    this.state = { failed: false }
  }

  componentDidCatch() {}

  render() {
    const { failed } = this.state
    const { children } = this.props

    return failed ? null : children
  }
}

export default QRBoundary
